import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { ObjectType } from '../../types/objectType';
import { setDefaultCups } from '../../redux/modules/reducer';

export const CustomInput = ({ defaultValue,
    options, id }: ObjectType) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState(defaultValue);


    const handleChange = (event: any) => {
        setValue(event.target.value as string);

        dispatch(setDefaultCups(event.target.value));
    };

    return (
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <TextField id="outlined-basic" label="CUPS" variant="outlined" onChange={handleChange} />
        </FormControl>
    );
};